import React, { PureComponent } from "react";
import InnerHTML from "../base/InnerHtml";
export default class StaticPage extends PureComponent<{ html: string }> {
  render() {
    return (
      <InnerHTML className="container static-page" html={this.props.html} />
    );
  }
}
